import React from 'react';
import Modal from 'react-modal';
import  clearIcon from '../../../assets/svg/icon_clear_modal.svg';
import { AppTooltip } from '../../atoms';
const ModalWindow = ({
  isOpen,
  heading,
  className,
  contentLabel,
  onRequestClose = null,
  children,
  info
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={`fqa-modal ${className}`}
      contentLabel={contentLabel}
      ariaHideApp={false}
    >
      <div className="fqa-modal--header">
        {onRequestClose ? (
          <button className="fqa-modal--close" title="Close" onClick={onRequestClose}>
           <img src={clearIcon}/>
          </button>
        ) : null}
        <h2 className="fqa-heading--primary mb-10">
          {info && <AppTooltip place='right' className="c-table-info-icon--tooltip" id="existing" />}
        {info && <i className='eva eva-alert-circle-outline' data-tip={heading}
          data-for="existing"></i>}
          {heading}</h2>
      </div>
      <div className="fqa-modal--body">{children}</div>
    </Modal>
  );
};

export default ModalWindow;
